<template>
    <template v-if="ready">
        <hr />
        <SquareBtn color="default"
                   size="lg"
                   block
                   :loading="loading"
                   @click="login">
            <i class="fa-brands fa-windows"></i>
            &nbsp;
            {{ l('LOGIN.SIGN_IN_ENTRA_ID') }}
        </SquareBtn>
    </template>
</template>

<script>
import SquareBtn from '@/vue/components/SquareBtn';
import { container } from '@/container';
import { UnmountedMixin } from '@/vue/mixins/UnmountedMixin';

export default {
    components: { SquareBtn },

    mixins: [
        UnmountedMixin,
    ],

    emits: [
        'error',
        'response',
    ],

    data() {
        return {
            ready: false,

            loading: false,
        };
    },

    async created() {
        this.loading = true;
        try {
            await container.entraIDAuthService.init();
            this.ready = true;

            // If the user clicked the Login With Entra ID button, and we are using the redirect auth flow,
            // they would have been redirected to Microsoft to login, and then sent back here with an code in
            // the URL hash.
            // In this case the page would have been loaded with '#code=0.AUgAJ3l80...' in the page hash but
            // the hash will have been replaced by our own routing logic. The original hash
            // is still available in window.requestedHash.
            // Give the requestedHash to the Entra ID code to check if we are returning from an auth redirect
            // and log in the user if so.
            container.entraIDAuthService.msal.handleRedirectPromise(window.requestedHash)
                .then(async (res) => {
                    if (this.unmounted) {
                        // It's possible during the startup flow for the LoginView to get created multiple
                        // times. It's caused be something modifying the page hash and I've spend a lot of time
                        // trying to figure out what with no answer. So to workaround that, check if this instance
                        // of LoginView is still mounted before we continue to login the user.
                        return;
                    }

                    if (res && res.idToken) {
                        console.debug('Entra ID user info loaded.', res);
                        this.loading = true;
                        container.entraIDAuthService.getUserDataFromIDToken(res.idToken)
                            .then((userData) => {
                                this.$emit('response', userData);
                            })
                            .catch((e) => {
                                this.$emit('error', e);
                            })
                            .finally(() => {
                                this.loading = false;
                            });
                    }
                })
                .catch((e) => {
                    this.$emit('error', e);
                });
        } catch (e) {
            console.error('Failed to initialize Entra ID login.', e);
            this.ready = false;
        } finally {
            this.loading = false;
        }
    },

    methods: {
        async login() {
            // Both redirect and popup methods are implemented. We originally used popup because it was a nicer
            // user experience. But it didn't work on Android. So now we use redirect instead.
            return this.loginWithRedirect();
        },

        async loginWithRedirect() {
            this.loading = true;
            container.entraIDAuthService
                .loginWithRedirect()
                .catch((e) => {
                    this.$emit('error', e);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        /**
         * Currently unused, but implemented if we want it.
         */
        async loginWithPopup() {
            this.loading = true;
            container.entraIDAuthService
                .loginWithPopup()
                .then((userData) => {
                    this.$emit('response', userData);
                })
                .catch((e) => {
                    this.$emit('error', e);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>
